var script = {
  name: 'PendoApp',
  provide() {
    return {
      $app: this
    };
  },
  props: {
    topbarHeight: {
      type: [Number, String],
      default: 0
    },
    footerHeight: {
      type: [Number, String],
      default: 0
    },
    sidebarWidth: {
      type: [Number, String],
      default: 0
    },
    backgroundColor: {
      type: String,
      default: '#FFFFFF'
    },
    pageBackgroundColor: {
      type: String,
      default: '#F8F8F9'
    }
  },
  data() {
    return {
      tabs: false
    };
  },
  methods: {
    updateProperty(property, value) {
      this[property] = value;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-app.vue2.js.map
